import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro'

let fingerprintAgent = null

export async function initFingerprintAgent() {
  if (fingerprintAgent) return fingerprintAgent
  fingerprintAgent = await FingerprintJS.load({
    apiKey: process.env.VUE_APP_FINGERPRINT,
  })
  return fingerprintAgent
}

export async function getVisitorId() {
  if (!fingerprintAgent) await initFingerprintAgent()
  const { visitorId } = await fingerprintAgent.get()
  return visitorId
}



// WEBPACK FOOTER //
// ./src/services/fingerprintService.js